import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Col, Container, Modal, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import { config } from "../../config";
import { goals } from "../../constants/goals";
import { logoutAction } from "../../store/actions/AuthAction";
import {
  addNewGoalAction,
  archiveGoalsAction,
  getGoalsAction,
  getHelpAction,
  refreshGoalsAction,
  updateGoalsAction,
} from "../../store/actions/GoalsAction";
import "./AppBanner.css";
import { ToastContainer, toast } from "react-toastify";

export default function AppBanner() {
  
  const dispatch = useDispatch();
  const history = useHistory();
  const globalStates = useSelector((state) => state);
  var goalsData = useSelector((state) => {
    return state.goals;
  });
  const [currentGoals, setCurrentGoals] = useState(goalsData?.goals?.map(goal => {
    if (goal.progress !== undefined) {
      return { ...goal, goalProgress: goal.progress};
    }
    return goal;
  }));
  const [selectChecked, setSelectChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [showHelp, setShowHelp] = useState(false)
  const [helpPayload, setHelpPayload] = useState([])

  const [newGoal, setNewGoal] = useState({
    achievedOn: null,
    deadline: "",
    description: "",
    goalOrder: 0,
    goalProgress: 0,
    parentGoalID: null,
    status: "",
    id: 0,
  });

  const createPayload = (id, comment) => {
    return {
      goalID: id,
      comment: comment,
    };
  };

  useEffect(() => {
    dispatch(getGoalsAction());
  }, []);


  useEffect(() => {
    setCurrentGoals(goalsData?.goals?.map(goal => {
      if (goal.progress !== undefined) {
        return { ...goal, goalProgress: goal.progress};
      }
      return goal;
    }));
    setSelectChecked(false);
  }, [globalStates?.goals]);

  useEffect(() => {
    if (
      globalStates?.goals?.update?.success ||
      globalStates?.goals?.archive?.success
    ) {
      setAlertShow(true);
    }
  }, [globalStates?.goals?.update, globalStates?.goals?.archive]);

  useEffect(() => {
    // setCurrentGoals(goalsData?.goals.sort((a,b) => a.goalOrder - b.goalOrder));

    if (!localStorage.getItem("userToken")) {
      history.replace("/");
      window.location.reload();
    }

    if (goalsData.updated) {
      handleClose(); //if add new modal is open
      dispatch(refreshGoalsAction());
      dispatch(getGoalsAction());
    }
  });

  const _handleGoalDescriptionChange = (e, index) => {
    const updatedGoals = currentGoals.map((goal) => {
      if (goal.id === index) {
        return { ...goal, description: e.target.value };
      }
      return goal;
    });
    setCurrentGoals(updatedGoals);
  };

  const _handleGoalDateChange = (e, index) => {
    const filterInput =
      currentGoals?.length > 0 &&
      currentGoals.map((goal) => {
        if (goal.id === index) {
          goal.deadline = new Date(e.target.value).getTime();
          return goal;
        } else {
          return goal;
        }
      });
    setCurrentGoals(filterInput);
  };

  const _handleGoalStatusChange = (e, index) => {
    const filterInput =
      currentGoals?.length > 0 &&
      currentGoals.map((goal) => {
        if (goal.id === index) {
          goal.status = e.target.value;
          return goal;
        } else {
          return goal;
        }
      });
    setCurrentGoals(filterInput);
    setSelectChecked(true);
    // if (e.target.value === "Completed") {
    //   setTimeout(() => {
    //     setSelectChecked(false);
    //   }, 2000);
    // }
  };

  const _handleGoalProgressChange = (e, index) => {
    const filterInput = currentGoals?.length > 0 &&
      currentGoals.map((goal) => {
        if (goal.id === index) {
          goal.goalProgress = e.target.value;
          return goal;
        } else {
          return goal;
        }
      });
    setCurrentGoals(filterInput);
  }

  const _handleGoalUpdate = (goal) => {
    const requestPayload = {
      action: "updateGoals",
      data: {
        token: localStorage.getItem("userToken"), //or fetch from auth redux state
        goals: [goal],
      },
    };
    dispatch(updateGoalsAction(requestPayload));
  };

  const _handleGoalArchive = (id) => {
    const requestPayload = {
      action: "archiveGoal",
      data: {
        token: localStorage.getItem("userToken"), //or fetch from auth redux state
        goalID: id,
      },
    };
    dispatch(archiveGoalsAction(requestPayload));
  };

  const _handleNewGoal = () => {
    setShow(true);
  };

  const handleClose = () => {
    initNewGoal();
    setShow(false);
  };

  const initNewGoal = () => {
    setNewGoal({
      achievedOn: null,
      deadline: new Date().getMilliseconds.toString(),
      description: "",
      goalOrder: 0,
      parentGoalID: null,
      goalProgress:0,
      status: "",
      id: 0,
    });
  };

  const handleAddGoal = () => {
    const requestPayload = {
      action: "createGoals",
      data: {
        token: localStorage.getItem("userToken"), //or fetch from auth redux state
        goals: [newGoal],
      },
    };
    dispatch(addNewGoalAction(requestPayload));
  };

  const formatDate = (date) => {
    return moment.utc(new Date(parseInt(date))).format("YYYY-MM-DD");
  };

  const showAlert =
    globalStates?.goals?.update?.success ||
    globalStates?.goals?.archive?.success;
  const alertType = showAlert ? "success" : "danger";

  const alertMessage = globalStates?.goals?.update?.success
    ? "Goals updated"
    : globalStates?.goals?.archive?.success
      ? "Goals archived"
      : globalStates?.goals?.add?.success
        ? "Goals added"
        : "";

  const _handleLogout = () => {
    //log user out
    dispatch(logoutAction);
    history.replace("/");
    window.location.reload();
  };


  const _handleChangeCheck = (id, checked, comment) => {
    if (checked) {
      const payload = createPayload(id, comment);
      setHelpPayload([...helpPayload.filter(item => item.goalID !== id), payload]);
    } else {
      setHelpPayload(helpPayload.filter((item) => item.goalID !== id));
    }
  };

  const _requestAssistance = () => {
    const payload = {
      action: "getHelp",
      data: {
        token: localStorage.getItem("userToken"), //or fetch from auth redux state
        items: helpPayload,
      },
    }
    dispatch(getHelpAction(payload)).then((res) => {
      if (res?.data?.status === 200) {
        toast.info("Assistance requested successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        setShowHelp(false)
        setHelpPayload([])
      } else {
        toast.info(res?.data?.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      }
    })
  }
  return (
    <div className="app-page">
      <ToastContainer/>
      <Container>
        <Form>
          <Row>
            <Col sm="12">
              {showAlert && alertShow && (
                <AlertSnackbar
                  isAlertShown={alertShow && showAlert}
                  alertType={alertType}
                  alertMessage={alertMessage}
                  setShow={() => setAlertShow(false)}
                />
              )}
            </Col>
          </Row>
          {currentGoals && currentGoals.length < 3 ? (
            <Row>
              <Col sm="12">
                <div className="add-goal">
                  <Button variant="primary" onClick={_handleNewGoal}>
                    Add New Goal
                  </Button>
                  &nbsp; &nbsp;
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      _handleLogout();
                    }}
                  >
                    Logout
                  </Button>
                </div>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          {(globalStates?.goals?.get?.loading ||
            globalStates?.goals?.update?.loading ||
            globalStates?.goals?.archive?.loading) && (
              <div className="loader-outer">
                <h3 className="txt-message">
                  {globalStates?.goals?.get?.loading
                    ? "Getting goals..."
                    : globalStates?.goals?.update?.loading
                      ? "Updating goals..."
                      : globalStates?.goals?.archive?.loading
                        ? "Archiving goals..."
                        : ""}
                </h3>
              </div>
            )}
          <Row style={{
            paddingTop:'20px'
          }}>
            <Col xs={10}></Col>
            <Col xs={2} style={{
              display: 'flex',
              flexDirection:'row-reverse'
            }}>
            <div>
              <button
                className="help-btn"
                style={{
                  backgroundColor: "#d7d9d7",
                  border: "none",
                  color: "#000",
                  borderRadius: "6px",
                  cursor: "pointer",
                  hover: "pointer",
                  width: "70px",
                }}
                  onClick={(e) => {
                    e.preventDefault()
                  setShowHelp(true)
                }}
                title="Request Help"
              >Help</button>
              </div>
            </Col>
          </Row>
          {currentGoals &&
            currentGoals.length > 0 &&
            currentGoals.map((goal, index) => {
              return (
                <Row className="goals-section" key={index}>
                  <Col sm="12">
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}>
                      <div className="title">
                        <h2>
                          Goal {index + 1}{" "}
                          {/* <Badge
                          bg={
                            goal.status === "Yet To Start"
                              ? "primary"
                              : goal.status === "Completed"
                              ? "success"
                              : goal.status === "In progress"
                              ? "primary"
                              : "danger"
                          }
                        >
                          {goal.status === "Yet To Start"
                            ? "Yet to start"
                            : goal.status === "Completed"
                            ? "Completed" 
                            : goal.status === "In progress"
                            ? "In progress"
                            : "danger"}
                        </Badge> */}
                        </h2>
                      </div>
                      
                    </div>
                  </Col>
                  <Col sm="12">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <div className="count-label">
                        <Form.Label>Description</Form.Label>
                        <span>{goal.description.length}/500</span>
                      </div>
                      <Form.Control
                        as="textarea"
                        placeholder="Enter description"
                        value={goal.description}
                        maxLength={500}
                        className="form-text-area-control"
                        name={goal.id}
                        onChange={(e) =>
                          _handleGoalDescriptionChange(e, goal.id)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <div style={{
                    display: "flex",
                    gap: "5px",
                    justifyContent: "space-between"
                  }}>
                    <Col md="3" sm="12">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>End date</Form.Label>
                        <br />
                        <input
                          type="date"
                          value={formatDate(goal.deadline)}
                          name={goal.id}
                          className="form-new-control"
                          max={moment().add(24, "months").format("YYYY-MM-DD")}
                          min={moment().format("YYYY-MM-DD")}
                          onChange={(e) => _handleGoalDateChange(e, goal.id)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Status</Form.Label>
                        <br />
                        <Form.Select
                          aria-label="Default select example"
                          value={goal.status}
                          name={goal.id}
                          onChange={(e) => _handleGoalStatusChange(e, goal.id)}
                        >
                          <option>Open this select menu</option>
                          {config?.goalStatusOptions?.length > 0 &&
                            config?.goalStatusOptions?.map((status, index) => {
                              return (
                                <option key={index} value={status.status}>
                                  {status.label}
                                </option>
                              );
                            })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      {goal.status === "In progress" ? (
                        <>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label>Goal Progress %</Form.Label>
                            <br />
                            <Form.Select
                              aria-label="Default select example"
                              value={goal.goalProgress}
                              name={goal.id}
                              onChange={(e) => _handleGoalProgressChange(e, goal.id)}
                            >
                              {config?.goalProgress?.length > 0 &&
                                config?.goalProgress?.map((status, index) => {
                                  return (
                                    <option key={index} value={status.value}>
                                      {status.label}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </Form.Group>
                        </>
                      ) : (<></>)}
                    </Col>
                    <Col md="3" sm="12" className="action-buttons">
                      <Button
                        variant="primary"
                        onClick={() => _handleGoalUpdate(goal)}
                        disabled={globalStates.loader.isLoading}
                      >
                        Update
                      </Button>
                      {!selectChecked &&
                        goalsData?.goals[index]?.status === "Completed" && (
                          <Button
                            variant="secondary"
                            onClick={() => {
                              _handleGoalArchive(goal.id);
                            }}
                          >
                            Archive
                          </Button>
                        )}
                    </Col>
                  </div>
                </Row>
              );
            })}
        </Form>
      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>Add new goal</Modal.Header>
        <Modal.Body>
          <Col xs="12">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <div className="count-label">
                <Form.Label>Description</Form.Label>
                <span>{newGoal.description.length}/500</span>
              </div>
              <Form.Control
                as="textarea"
                placeholder="Enter description"
                value={newGoal.description}
                maxLength={500}
                className="form-text-area-control"
                name={newGoal.id}
                onChange={(e) =>
                  setNewGoal({ ...newGoal, description: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col xs="12">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>End date</Form.Label>
              <br />
              <Form.Control
                type="date"
                value={formatDate(newGoal.deadline)}
                name={newGoal.id}
                className="form-new-control"
                onChange={(e) =>
                  setNewGoal({
                    ...newGoal,
                    deadline: new Date(e.target.value).getTime(),
                  })
                }
                max={moment().add(24, "months").format("YYYY-MM-DD")}
                min={moment().format("YYYY-MM-DD")}
              />
            </Form.Group>
          </Col>
          <Col xs="12">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Status</Form.Label>
              <br />
              <Form.Select
                aria-label="Default select example"
                value={newGoal.status}
                name={newGoal.id}
                onChange={(e) =>
                  setNewGoal({ ...newGoal, status: e.target.value })
                }
              >
                <option value={""}>Open this select menu</option>
                {config?.goalStatusOptions?.length > 0 &&
                  config?.goalStatusOptions?.map((status, index) => {
                    return (
                      <option key={index} value={status.status}>
                        {status.label}
                      </option>
                    );
                  })}
              </Form.Select>
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={
              newGoal.description.length < 1 ||
              newGoal.status.length === 0 ||
              !moment(new Date(newGoal.deadline)).isValid()
            }
            onClick={() => handleAddGoal()}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
        <Modal show={showHelp} onHide={() => setShowHelp(false)}>
          <Modal.Header>
            Request assistance
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <p>Please Select the goals you need assistance and provide neccessary information</p>
              </Col>
            </Row>
            <Row>
              <Col>
            {
              currentGoals &&
              currentGoals.length > 0 &&
                  currentGoals.map((goal, index) => { 
                    if (goal.status !== "Completed") {
                      const checkedGoal = helpPayload.find((item) => item.goalID === goal.id);
                      return (
                        <div key={goal.id} style={{ margin: '10px' }}>
                          <label>
                            <input
                              type="checkbox"
                              style={{ marginRight: '10px' }}
                              onChange={(e) => _handleChangeCheck(goal.id, e.target.checked, '')}
                            />
                            Goal {index + 1}
                          </label>
                          <br/>
                          <div>
                            <label>Description : &nbsp; {goal.description}</label>
                          </div>
                          {checkedGoal && (
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                              <div className="count-label">
                                <Form.Label>Comment</Form.Label>
                                <span></span>
                              </div>
                              <Form.Control
                                as="textarea"
                                placeholder="Enter comments"
                                value={checkedGoal.comment}
                                maxLength={500}
                                className="form-text-area-control"
                                name={goal.id}
                                onChange={(e) => _handleChangeCheck(goal.id, true, e.target.value)}
                              />
                            </Form.Group>
                          )}
                        </div>
                      );
                    } else {
                      return null;
                    }
              })
                }
              </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={_requestAssistance}>
            Submit
          </Button>
        </Modal.Footer>
        </Modal>
    </div>
  );
}
